import React, { useState, useEffect, useImperativeHandle, } from 'react';
import { Image, Nav, Navbar, Container, NavDropdown } from 'react-bootstrap';

import { useLocation, useHistory } from 'react-router-dom';
import logo_framework from '../../../assets/img/AVAP_Marketplace.png';


import SessionExpired from '../../Modals/sessionExpired';
import InactivityModal from '../../Modals/inactivityModal';

//services
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
import Cookies from 'universal-cookie';
import SessionService from '../../../services/SessionsService';
import config from '../../../configs/appConfig.json'
import ReactGA from 'react-ga4';

//dummyData
import profilePicture from '../../../assets/img/placeholder/profile.jpeg';




const BrowserNavbar = () => {

  // console.log(SessionService);

 

  const isActive = (path) => {
    return location.pathname.startsWith(path) ? 'active' : '';
  };

  const history = useHistory();

  const [get_personal_info, setGet_personal_info] = useState<any>({});
  const [isLoggedIn, setLogged] = useState(false);
  const [client, setClient] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [inactivity, setInactivity] = useState(false);
  const cookies = new Cookies();




  const getPersonalInformation = async () => {
    try {
      const cachedInfo = localStorage.getItem('userPersonalInfo');
      if (cachedInfo) {
        setGet_personal_info(JSON.parse(cachedInfo));
        return;
      }

      const result = (await ObexRequestHandler.get('/get_personal_info')).data;
      if (result == undefined) {
        SessionService.logout();
        window.location.replace('/marketplaceStore')
        return;
      }

      // Guardamos la información en localStorage
      localStorage.setItem('userPersonalInfo', JSON.stringify(result));
      setGet_personal_info(result);

    } catch (error) {
      console.error('ERROR FETCHING PERSONAL INFO ', error);
    }
  }




  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // limpiar la informacion del usuario
    localStorage.removeItem('userPersonalInfo');
    SessionService.logout();
    setLogged(false);
    if (history.location.pathname === '/marketplaceStore') {
      window.location.reload();
    } else {
      history.push('/marketplaceStore');
    }
  }




  useEffect(() => {
    if (config.url != 'https://avs-primary-pre.101obex.mooo.com') 
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Marketplace' });

    const user = cookies.get('101Obex');
    setClient(SessionService.Client);
    
    if (user) {
      if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
        SessionService.renewSession();
      }
      setLogged(true);
      getPersonalInformation();
    }
  }, [])

  const navigateToMyApis = (e) => {
    e.preventDefault();
    history.push('/myApis');
  };

  return (
    <>
      <Navbar bg="light" expand="lg">
        <Container className='px-0'>
          <Navbar.Brand href="#home">
            <Image src={logo_framework} alt="Logo Marketplace" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            {!isLoggedIn ? (

              <>
                <Nav className='me-auto '>
                  <Nav.Link href="https://developer.avapframework.com/wiki/over_view14a-PUBLISH_SAMPLE_1/0" target='_blank' className="">
                  How to publish an API Product
                  </Nav.Link>
                  <Nav.Link href="/login" className="">
                    Sign in with your AVAP ID
                  </Nav.Link>
                </Nav>
              </>) : (

              <>
                <Nav className="mr-auto">
                 
                </Nav>
                <Nav className='mr-sm-2 align-items-center'>
                  <Nav.Link onClick={navigateToMyApis}>My API Products</Nav.Link>
                  <Nav.Link onClick={handleLogout}>Sign out</Nav.Link>
                  <div className='d-flex align-items-center px-2'>
                    <>
                      <p className='name'>
                        {get_personal_info && get_personal_info.first_name} {get_personal_info && get_personal_info.middle_name} {get_personal_info && get_personal_info.last_name}
                        {/* {get_personal_info && get_personal_info.email} */}
                      </p>
                      <div id='#profilePicture' className='profilePicture' style={{ backgroundImage: `url(${SessionService.imageContent})` }}></div>
                    </>
                  </div>
                </Nav>
              </>

            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );

};

export default BrowserNavbar;


